/**
 * @file customerChange.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-07
 * @modified 2026-10-07
 * @description How a "Change customer…" on a till document reads wherever it
 *              is shown — Till Sales, Search Invoices and the invoice window:
 *              "Customer changed: POS Customer → E W Underhill & Son — <reason>
 *              (Jade Games, 7 Oct)". The entries are the server's
 *              invoices.customer_changes (services/tillCustomerChangeService.js).
 */

const partyName = (p) => (p && (p.name || (p.account_no ? `Account ${p.account_no}` : null))) || 'unknown';

/** "7 Oct", or "7 Oct 2025" for a change in an earlier year. */
export function shortDay(iso, now = new Date()) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const opts = { day: 'numeric', month: 'short', timeZone: 'Europe/London' };
  if (d.getFullYear() !== now.getFullYear()) opts.year = 'numeric';
  return d.toLocaleDateString('en-GB', opts);
}

/** One change as a sentence. */
export function describeCustomerChange(entry, now = new Date()) {
  if (!entry) return '';
  const who = [entry.by && entry.by.name, entry.at && shortDay(entry.at, now)].filter(Boolean).join(', ');
  const reason = entry.reason ? ` — ${entry.reason}` : '';
  return `Customer changed: ${partyName(entry.from)} → ${partyName(entry.to)}${reason}${who ? ` (${who})` : ''}`;
}

/** Every change, newest first, one per line — for a tooltip. */
export function describeCustomerChanges(list, now = new Date()) {
  const items = Array.isArray(list) ? list : [];
  return items.slice().reverse().map(e => describeCustomerChange(e, now)).join('\n');
}

/** The latest change, or null. */
export function latestCustomerChange(list) {
  return Array.isArray(list) && list.length ? list[list.length - 1] : null;
}
